import * as React from "react"
import { ReactElement, useState } from "react"
import Notification from "@rio-cloud/rio-uikit/Notification"
import ConfirmationDialog from "@rio-cloud/rio-uikit/ConfirmationDialog"
import Checkbox from "@rio-cloud/rio-uikit/Checkbox"
import { FormattedMessage, useIntl } from "react-intl"
import { v4 as uuid } from "uuid"
import { useGetAgreementsQuery, usePutAgreementMutation } from "../../client/agreement/agreeementApi"

export const AgreementDialog = (): React.ReactElement => {
    const { data, isLoading, isError } = useGetAgreementsQuery()
    const [putAgreementMutation, putAgreementMutationState] = usePutAgreementMutation()
    const [termsAndConditionsAgreementChecked, setTermsAndConditionsAgreementChecked]= useState<boolean>(false)
    const [dataProcessingAgreementChecked, setDataProcessingAgreementChecked] = useState<boolean>(false)

    const intl = useIntl()

    const handleTermsAndConditionsAgreementCheck = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setTermsAndConditionsAgreementChecked(event.target.checked)
    }

    const handleDataProcessingAgreementCheck = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setDataProcessingAgreementChecked(event.target.checked)
    }

    const handleSubmit = (): Promise<void> =>
        putAgreementMutation({ id: uuid() })
            .unwrap()
            .catch(() => {
                Notification.error(<FormattedMessage id={"termsAndConditions.agreement.dialog.agreementFailed"}/>)
            })


    const renderDialogContent = (): ReactElement => {
        return (
            <div className={"display-flex flex-column"}>
                <p>
                    <FormattedMessage id={"termsAndConditions.agreement.dialog.text"}/>
                </p>
                <div className={"display-flex flex-row"}>
                    <Checkbox onChange={(event): void => handleTermsAndConditionsAgreementCheck(event)}>
                        <FormattedMessage id={"termsAndConditions.agreement.dialog.checkTermsAndConditionsLabel"} values={{
                            _linkTermsConditions: <a href={intl.formatMessage({ id: "termsAndConditions.agreement.dialog.checkTermsAndConditionsLabel.linkTermsConditions.href" })}
                                target="_blank"
                                rel="noopener noreferrer">
                                <FormattedMessage id={"termsAndConditions.agreement.dialog.checkTermsAndConditionsLabel.linkTermsConditions.text"}/>
                            </a>,
                            _linkSpecifications: <a href={intl.formatMessage({ id: "termsAndConditions.agreement.dialog.checkTermsAndConditionsLabel.linkSpecifications.href" })}
                                target="_blank"
                                rel="noopener noreferrer">
                                <FormattedMessage id={"termsAndConditions.agreement.dialog.checkTermsAndConditionsLabel.linkSpecifications.text"}/>
                            </a>,
                        }}/>
                    </Checkbox>
                </div>
                <div className={"display-flex flex-row"}>
                    <Checkbox onChange={(event): void => handleDataProcessingAgreementCheck(event)}>
                        <FormattedMessage id={"termsAndConditions.agreement.dialog.checkDataProcessingLabel"} values={{
                            _link: <a href={intl.formatMessage({ id: "termsAndConditions.agreement.dialog.checkDataProcessingLabel.link.href" })}
                                target="_blank"
                                rel="noopener noreferrer">
                                <FormattedMessage id={"termsAndConditions.agreement.dialog.checkDataProcessingLabel.link.text"}/>
                            </a>,
                        }}/>
                    </Checkbox>
                </div>
            </div>
        )
    }

    const showDialog = !isLoading && (isError || data?.length === 0)
    const disableConfirmButton = !termsAndConditionsAgreementChecked || !dataProcessingAgreementChecked || putAgreementMutationState.isLoading

    return (
        <ConfirmationDialog
            show={showDialog}
            content={renderDialogContent()}
            title={<FormattedMessage id={"termsAndConditions.agreement.dialog.title"}/>}
            useOverflow={false}
            cancelButtonText={<FormattedMessage id={"termsAndConditions.agreement.dialog.cancel"}/>}
            confirmButtonText={<FormattedMessage id={"termsAndConditions.agreement.dialog.confirm"}/>}
            disableConfirm={disableConfirmButton}
            onClickCancel={(): void => {
                window.history.back()
            }}
            onClickConfirm={(): Promise<void> => handleSubmit()}
        />
    )
}
